import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Stack from '../Stack';
var Legends = styled(Stack).withConfig({
  displayName: "Legendsstyles__Legends",
  componentId: "sc-1gr5q48-0"
})(["margin:-12px 0 0 -24px;width:calc(100% + 24px);& > *{margin:12px 0 0 24px;}"]);
var LegendsItem = styled.div.withConfig({
  displayName: "Legendsstyles__LegendsItem",
  componentId: "sc-1gr5q48-1"
})(["display:inline-flex;align-items:center;flex-wrap:wrap;"]);
var LegendsKey = styled.div.withConfig({
  displayName: "Legendsstyles__LegendsKey",
  componentId: "sc-1gr5q48-2"
})(["width:", ";position:relative;overflow:hidden;border-radius:1px;margin-right:8px;height:", ";", " ", ""], rem(14), function (props) {
  return props.type === 'block' ? rem(14) : rem(2);
}, function (props) {
  return props.color ? css(["background-color:", ";"], props.color) : css(["box-shadow:inset 0 0 0 1px var(--dentsu-color-n250);"]);
}, function (props) {
  return props.isPattern && css(["background-color:", ";background-image:repeating-linear-gradient( 135deg,transparent,var(--dentsu-color-white) 1.5px,transparent 3px );"], props.color);
});
var LegendsLabel = styled.span.withConfig({
  displayName: "Legendsstyles__LegendsLabel",
  componentId: "sc-1gr5q48-3"
})(["font-size:var(--dentsu-font-size-11);color:var(--dentsu-color-black);"]);
export var Styled = {
  Legends: Legends,
  LegendsItem: LegendsItem,
  LegendsKey: LegendsKey,
  LegendsLabel: LegendsLabel
};